module.exports = __webpack_public_path__ + "static/NodeJS-65eb8945b52acc84ea5a4dbb77354efe.mp4";